module.exports = __webpack_public_path__ + "img/ios-screenshot-sr.7ccf2c73.png";